// src/pages/offlineSales/terminal/components/LoyaltyRedeemModal.jsx
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useLocalization } from '../../../../contexts/LocalizationContext';
import styles from '../OfflineSalesTerminal.module.css';

const LoyaltyRedeemModal = ({ customer, settings, grandTotal, currentPoints, onApply, onClose }) => {
  const { t, formatCurrency } = useLocalization();
  const [pointsInput, setPointsInput] = useState(currentPoints > 0 ? String(currentPoints) : '');

  const balance = customer?.loyaltyPoints || 0;
  const pointValue = parseFloat(settings?.loyaltyPointValueRupees || 0);
  const minPoints = parseInt(settings?.loyaltyMinRedeemPoints || 0);
  const maxPct = parseFloat(settings?.loyaltyMaxRedeemPct || 100);
  const maxDiscount = grandTotal * (maxPct / 100);
  const maxRedeemableByDiscount = maxDiscount > 0 ? Math.floor(maxDiscount / pointValue) : 0;
  const maxPoints = Math.min(balance, maxRedeemableByDiscount);

  const points = Math.min(parseInt(pointsInput) || 0, maxPoints);
  const discount = points * pointValue;

  const canApply = points >= minPoints && points > 0;

  const handleApply = () => {
    if (canApply) {
      onApply(points);
      onClose();
    }
  };

  const handleRemove = () => {
    onApply(0);
    onClose();
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={`${styles.modal} ${styles.modalSm}`} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>{t('pos.redeemLoyalty')}</h3>
          <button onClick={onClose} className={styles.modalClose}><X size={18} /></button>
        </div>

        <div className={styles.loyaltyInfo}>
          <div className={styles.loyaltyRow}>
            <span>{t('pos.loyaltyBalance')}</span>
            <strong>{balance} pts</strong>
          </div>
          <div className={styles.loyaltyRow}>
            <span>{t('pos.pointValue')}</span>
            <strong>{formatCurrency(pointValue)} / pt</strong>
          </div>
          <div className={styles.loyaltyRow}>
            <span>{t('pos.minPoints')}</span>
            <strong>{minPoints} pts</strong>
          </div>
          <div className={styles.loyaltyRow}>
            <span>{t('pos.maxDiscount')}</span>
            <strong>{formatCurrency(maxDiscount)} ({maxPct}%)</strong>
          </div>
        </div>

        <label className={styles.formLabel}>{t('pos.pointsToRedeem')}</label>
        <input
          autoFocus
          type="number"
          min="0"
          max={maxPoints}
          step="1"
          value={pointsInput}
          onChange={e => setPointsInput(e.target.value)}
          className={styles.formInput}
        />
        <small className={styles.formHint}>Max: {maxPoints} pts</small>

        {points > 0 && (
          <div className={styles.discountPreview}>
            {t('pos.discountPreview')}: <strong>{formatCurrency(discount)}</strong>
          </div>
        )}

        <div className={styles.modalFooter}>
          {currentPoints > 0 && (
            <button onClick={handleRemove} className={styles.actionBtnSecondary}>
              {t('pos.removeRedemption')}
            </button>
          )}
          <button onClick={onClose} className={styles.actionBtnSecondary}>
            {t('common.cancel', 'Cancel')}
          </button>
          <button onClick={handleApply} disabled={!canApply} className={styles.chargeBtn}>
            {t('pos.redeemPoints')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyRedeemModal;
